import { Pipe, PipeTransform } from '@angular/core';

const PROXY_BASE_URL = 'https://img.noodl.ist';

export interface ImageProxyUrlOptions {
  width: number;
  height: number;
  format?: string;
  quality?: number;
}

@Pipe({
  name: 'imageProxy',
  standalone: true,
})
export class ImageProxyPipe implements PipeTransform {
  transform(filename: string, options: ImageProxyUrlOptions): string {
    if (!filename) {
      throw new Error('ImageProxyPipe requires a filename to transform.');
    }

    if (!options) {
      throw new Error('ImageProxyPipe requires an options object.');
    }

    const { width, height, format, quality } = options;

    if (!Number.isFinite(width) || width <= 0 || !Number.isFinite(height) || height <= 0) {
      throw new Error('ImageProxyPipe requires width and height to be positive finite numbers.');
    }

    if (quality !== undefined && (!Number.isFinite(quality) || quality < 0 || quality > 100)) {
      throw new Error('ImageProxyPipe requires quality to be a finite number between 0 and 100.');
    }

    const normalizedFilename = filename.replace(/^\/+/, '').trim();
    if (!normalizedFilename) {
      throw new Error('ImageProxyPipe requires a filename to transform.');
    }

    const safeFilename = normalizedFilename
      .split('/')
      .filter((segment) => segment.length > 0)
      .map((segment) => {
        try {
          return encodeURIComponent(decodeURIComponent(segment));
        } catch {
          return encodeURIComponent(segment);
        }
      })
      .join('/');

    const proxyUrl = new URL(`${PROXY_BASE_URL}/${safeFilename}`);
    proxyUrl.searchParams.set('width', String(width));
    proxyUrl.searchParams.set('height', String(height));

    if (format) {
      proxyUrl.searchParams.set('format', format);
    }

    if (quality !== undefined) {
      proxyUrl.searchParams.set('quality', String(quality));
    }

    return proxyUrl.toString();
  }
}
